import { gql } from '@apollo/client'
import { SABRE_MANUFACTURER_FRAGMENT } from '../fragments'

export const SABRE_GET_MANUFACTURERS = gql`
  query GetManufacturers($input: ManufacturersInput) {
    manufacturers(input: $input) {
      count
      hasMore
      results {
        ...Manufacturer
      }
    }
  }
  ${SABRE_MANUFACTURER_FRAGMENT}
`
